import { createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pb-6 px-0 sm:px-6 sm:shadow-sm" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "text-center text-2xl text-gray-800 sm:text-gray-600 font-header mb-8" }, " Verify your device ", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-center text-gray-600 mb-8" }, " This device isn't recognized. We have sent you an email to your email address on file. For your security, enter the your verification code, from the email, in order to continue. ", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-center text-gray-600 mb-8" }, " It still looks like you need to verify your current device. Unfortunately, this page has expired. Click on the button below and we will send you a new verification code to the email on file. ", -1)
const _hoisted_6 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Alert = _resolveComponent("Alert")
  const _component_Input = _resolveComponent("Input")
  const _component_LoaderIcon = _resolveComponent("LoaderIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.alert.display)
      ? _createVNode(_component_Alert, {
          key: 0,
          type: _ctx.alert.type,
          message: _ctx.alert.message
        }, null, 8, ["type", "message"])
      : _createCommentVNode("", true),
    (!_ctx.expired)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _hoisted_3,
          _createVNode(_component_Form, {
            valid: _ctx.valid,
            "onUpdate:valid": _cache[3] || (_cache[3] = $event => (_ctx.valid = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                label: "Enter Your Verification Code",
                value: _ctx.form.verify.value,
                "onUpdate:value": _cache[1] || (_cache[1] = $event => (_ctx.form.verify.value = $event)),
                rules: _ctx.form.verify.rules
              }, null, 8, ["value", "rules"]),
              _createVNode(_component_Button, {
                "is-disabled": !_ctx.valid || _ctx.loading,
                color: "secondary",
                "onOn-click": _cache[2] || (_cache[2] = $event => (_ctx.submitVerify()))
              }, {
                default: _withCtx(() => [
                  (_ctx.loading)
                    ? _createVNode(_component_LoaderIcon, {
                        key: 0,
                        class: "animate-spin -ml-1 mr-3 h-5 w-5 text-gray-600"
                      })
                    : _createCommentVNode("", true),
                  (!_ctx.loading)
                    ? (_openBlock(), _createBlock("span", _hoisted_4, "Submit"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["is-disabled"])
            ]),
            _: 1
          }, 8, ["valid"])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("", true),
    (_ctx.expired)
      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
          _hoisted_5,
          _createVNode(_component_Button, {
            "is-disabled": _ctx.emailSent || _ctx.loading,
            color: "secondary",
            "onOn-click": _cache[4] || (_cache[4] = $event => (_ctx.resendEmail()))
          }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? _createVNode(_component_LoaderIcon, {
                    key: 0,
                    class: "animate-spin -ml-1 mr-3 h-5 w-5 text-gray-600"
                  })
                : _createCommentVNode("", true),
              (!_ctx.loading)
                ? (_openBlock(), _createBlock("span", _hoisted_6, "Resend Email"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["is-disabled"])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("", true)
  ]))
}